<template>
  <van-popup
      :value="value"
      @input="onShowChange"
      :close-on-click-overlay="false"
      :style="{ width: '90%' ,'--resultColor': resultColor}">

    <div class="vertical items-center verify-result-wrap ">
      <van-image :src="resultIcon" width="40" height="40"/>
      <div class="make-by" style="font-size:26px;">IT'S MADE BY {{ deviceInfo.brandName }}</div>
      <van-image :src="deviceInfo.flavorPicture" height="220" fit="contain"/>

      <div class="device-result-props">
        <div v-for="(item,index) in deviceInfo.items" :key="index">
          {{ item.key }}: {{ item.value }}
        </div>
      </div>


      <div class="footer">
        <div class="footer-confirm" @click="onConfirmClick">
          Check Another One
        </div>
      </div>
    </div>


    <div class="flex flex-col items-center">
      <img :src="require('@/assets/icons/v2/icon_popup_close.png')" class="w-9 h-9 mt-6 p-2"
          @click="onCancel(false)"/>
    </div>
  </van-popup>


</template>

<script>
import log from "@/util/log";
import ProductItem from "@/components/customization/ProductItem.vue";

export default {
  name: "PopupVerifyResult",
  components: { ProductItem },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    deviceInfo: {
      type: Object,
      require: true
    }
  },

  data() {
    return {
      showPopup: false,
      content: "",
    };
  },

  methods: {
    onConfirmClick() {
      this.$emit("input", false);
      this.$emit('onConfirmClick',this.deviceInfo.tag)
    },
    onShowChange() {

    },
    onCancel() {
      this.$emit("input", false);
      this.$emit("onClose");
    }
  },
  computed: {
    isSuccess() {
      return this.deviceInfo.queryCount <= 10
    },
    resultIcon() {
      if (this.isSuccess) {
        return require('@/assets/icons/nico/ic_verify_success.svg')
      }
      return require('@/assets/icons/nico/ic_verify_fail.svg')
    },
    resultColor() {
      return this.isSuccess ? '#A5C130': 'red'
    }
  },
  mounted() {
  }
};
</script>


<style scoped lang="less">

.van-popup {
  background: transparent;
}

.make-by {
  color: var(--resultColor)
}

.verify-result-wrap {
  font-size: 16px;
  padding: 16px;
  background: white;
  text-align: center;
  color: var(--resultColor);
  font-family: 'outfit';
  border-radius: 14px;

  & > * + * {
    margin-top: 16px;
  }


  .footer {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 20px;
    background: black;
    height: 41px;

    .footer-confirm {
      color: #ffffff;
      width: 100%;
      font-weight: normal;
    }
  }
}

.device-result-props {
  font-size: 12px;
  color: #000000;
  rder-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > * + * {
    margin-top: 4px;
  }

}
</style>